import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import '../../css/login.css';
import t3Logo from '../../assets/finsi_logo.png';
import { Link } from 'react-router-dom';

import { getCurrentUser, handleResendVerificationField, resendVerificationCode } from '../../store/actions/users/usersActions';

class ResendVerificationCode extends Component {

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.resendVerificationCode(() => {
      this.props.history.push('/resend-verification-code');
    });
  }

  render() {
    const apiToken = Cache.getItem('apiToken');
    if (!apiToken) {
      let submitValue = 'Submit';
      let isResending = this.props.users.resendingVerificationCode;
  
      if (isResending) {
        submitValue = <Spinner animation="border" size="sm" />
      }
      
      return (
        <React.Fragment>
          <Row id="resend-verification-page">
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <img className="company-logo" src={t3Logo} alt="t3-logo" width="100%" height="auto" />
              <h5 id="resend-verification-header-text">Resend Verification Code</h5> 
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="email">
                  <Form.Label id="company-lbl">Company Email</Form.Label>
                  <Form.Control type="text" placeholder="Enter Company Email" onChange={this.props.handleResendVerificationField} />
                </Form.Group>
                <Button variant="primary" id="t3-login-button" size="sm" block type="submit">
                  {submitValue}
                </Button>
                <Link id="back-to-login" to="#" onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push('/');
                }}>
                  Back to Login
                </Link>
              </Form>
            </Col>
          </Row>
        </React.Fragment>
      )
    }
    else {
      return (
        <Spinner animation="border" size="sm" />
      )
    }
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    handleResendVerificationField: (...args) => dispatch(handleResendVerificationField(...args)),
    resendVerificationCode: (...args) => dispatch(resendVerificationCode(...args)),
    getCurrentUser: (...args) => dispatch(getCurrentUser(...args))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResendVerificationCode)
